import { render, staticRenderFns } from "./guaranteeDetail.vue?vue&type=template&id=06d578a1&scoped=true"
import script from "./guaranteeDetail.vue?vue&type=script&lang=ts"
export * from "./guaranteeDetail.vue?vue&type=script&lang=ts"
import style0 from "./guaranteeDetail.vue?vue&type=style&index=0&id=06d578a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d578a1",
  null
  
)

export default component.exports